import { AfterViewInit, Component, Input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { SafeResourceUrl } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'bank-transfer',
  templateUrl: './bank-transfer.component.html',
  styleUrls: ['./bank-transfer.component.scss'],
})
export class BankTransferComponent implements AfterViewInit {
  tooltipMessage: string = 'bankTransfer:tooltipMessage';

  constructor(private readonly translate: TranslateService) {}

  ngAfterViewInit(): void {
    const tempElement = document.createElement('section');

    if (this.bankTransferData) {
      tempElement.innerHTML = this.bankTransferData;

      this.mapTableToJson(tempElement);
    }
  }

  @Input() paymentAmount!: string;
  @Input() paymentCurrency!: string;
  @Input() paymentMethods!: any[];
  @Input() expiryDate!: Date | null;
  @Input() bankTransferData?: string;
  @Input() externalPaymentUrl?: SafeResourceUrl;
  @Input() convertedAmount: string | null = null;
  @Input() convertedCurrency: string | null = null;
  @Input() type?: 'Invoice' | 'PaymentRequest' | 'Commission' = 'PaymentRequest';

  bankTransferDetails: {
    index: number;
    key: string | null;
    value: string | null;
  }[] = [];

  hoveredIndex: number | null = null;

  isExternalPayment() {
    return this.externalPaymentUrl && !this.bankTransferData;
  }

  get isCommissionType() {
    return this.type === 'Commission';
  }

  get isExpired() {
    return this.expiryDate && this.expiryDate < new Date();
  }

  ngOnChanges() {
    this.getBankTransferPaymentAmount();
  }

  private getBankTransferPaymentAmount() {
    const [bankTransfer] = this.paymentMethods.filter((method) => {
      return (
        method.paymentMethod?.includes('Bank Transfer') ||
        method.type.includes('Bank Transfer')
      );
    });

    if (!this.convertedAmount) {
      if (bankTransfer?.convertedAmount && bankTransfer?.convertedCurrency) {
        this.convertedAmount = bankTransfer?.convertedAmount;
        this.convertedCurrency = bankTransfer.convertedCurrency;
      }
    }
  }

  public getMonthName(month: number): string {
    const months: { [k: number]: string } = {
      0: 'Jan',
      1: 'Feb',
      2: 'Mar',
      3: 'Apr',
      4: 'May',
      5: 'Jun',
      6: 'Jul',
      7: 'Aug',
      8: 'Sep',
      9: 'Out',
      10: 'Nov',
      11: 'Dec',
    };

    return months[month];
  }

  private mapTableToJson(tempElement: HTMLElement): void {
    const rows =
      tempElement.getElementsByClassName('bank-details')[0]?.children[0]
        ?.children;

    if (rows) {
      for (var i = 0; i < rows.length; i++) {
        // If the key is 'Please Note' then the value is 'PIX' for Brazilian bank transfers
        const key = rows[i].children[0].textContent?.startsWith('Please Note')
          ? 'PIX'
          : rows[i].children[0].textContent;

        // If the value contains 'PIX' then the value is the element after the ':'
        const value = rows[i].children[1].textContent?.startsWith('PIX')
          ? rows[i].children[1].textContent?.split(':')[1].split('\n')[0].trim()
          : rows[i].children[1].textContent;

        if (value?.includes('Atenção')) {
          const pixKey = value.split('Atenção')[0];
          this.bankTransferDetails[i] = {
            index: i,
            key: key?.replace(/\s/g, '') ?? '',
            value: pixKey?.trim() ?? '',
          };
        } else {
          this.bankTransferDetails[i] = {
            index: i,
            key: key?.replace(/\s/g, '') ?? '',
            value: value?.trim() ?? '',
          };
        }
      }
    }
  }

  public copyToClipboard(value: string | null, tooltip: MatTooltip): void {
    if (value) {
      navigator.clipboard.writeText(value).then(() => {
        this.tooltipMessage = this.translate.instant(
          'bankTransfer:copyMessage',
        );

        tooltip.show();

        setTimeout(() => {
          this.tooltipMessage = 'bankTransfer:tooltipMessage';
          tooltip.hide();
        }, 2000);
      });
    }
  }
}
